import { render } from "./ProductRecommendations.vue?vue&type=template&id=1edf93c2&scoped=true"
import script from "./ProductRecommendations.vue?vue&type=script&lang=js"
export * from "./ProductRecommendations.vue?vue&type=script&lang=js"

import "./ProductRecommendations.vue?vue&type=style&index=0&id=1edf93c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edf93c2"]])

export default __exports__